export const normalizeIcon = (Icon) => {
    return (Icon.default ? Icon.default : Icon);
};
